<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>To all the women who have ever felt helpless, hopeless and voiceless, this book is for you. I pray that this story will help you to find your voice and that it gives you the courage to stand up and proclaim your truth, unapologetically.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?0518405b